import { useParams, useSearchParams } from 'react-router-dom';
import OracleDeckGrid from '../../components/oracle/OracleDeckGrid';
import HomePageEs from './HomePageEs';
import HomePageEn from './HomePageEn';

function HomePage() {
  const { lang } = useParams();

  return (<>
    {lang == 'es' ? <HomePageEs/> : <HomePageEn/>}
  </>);
}

export default HomePage;